export default class VerticesToFaceMap<T> extends Map<string, T> {
  private static makeKey(a: number, b: number, c: number): string {
    const s = [a, b, c].sort((x, y) => x - y);
    return `${s[0]}_${s[1]}_${s[2]}`;
  }

  // --- GET ---
  override get(key: string | [number, number, number] | number, b?: number, c?: number): T | undefined {
    if (typeof key === 'string') return super.get(key);
    if (Array.isArray(key)) return super.get(VerticesToFaceMap.makeKey(key[0], key[1], key[2]));
    if (typeof key === 'number' && typeof b === 'number' && typeof c === 'number') {
      return super.get(VerticesToFaceMap.makeKey(key, b, c));
    }
    throw new Error('Invalid key format for get');
  }

  // --- SET ---
  override set(key: string | [number, number, number] | number, valueOrB: T | number, c?: number, valueIfNums?: T): this {
    if (typeof key === 'string') return super.set(key, valueOrB as T);
    if (Array.isArray(key)) return super.set(VerticesToFaceMap.makeKey(key[0], key[1], key[2]), valueOrB as T);
    if (typeof key === 'number' && typeof valueOrB === 'number' && typeof c === 'number' && valueIfNums !== undefined) {
      return super.set(VerticesToFaceMap.makeKey(key, valueOrB, c), valueIfNums);
    }
    throw new Error('Invalid key/value format for set');
  }

  // --- HAS ---
  override has(key: string | [number, number, number] | number, b?: number, c?: number): boolean {
    if (typeof key === 'string') return super.has(key);
    if (Array.isArray(key)) return super.has(VerticesToFaceMap.makeKey(key[0], key[1], key[2]));
    if (typeof key === 'number' && typeof b === 'number' && typeof c === 'number') {
      return super.has(VerticesToFaceMap.makeKey(key, b, c));
    }
    throw new Error('Invalid key format for has');
  }

  // --- DELETE ---
  override delete(key: string | [number, number, number] | number, b?: number, c?: number): boolean {
    if (typeof key === 'string') return super.delete(key);
    if (Array.isArray(key)) return super.delete(VerticesToFaceMap.makeKey(key[0], key[1], key[2]));
    if (typeof key === 'number' && typeof b === 'number' && typeof c === 'number') {
      return super.delete(VerticesToFaceMap.makeKey(key, b, c));
    }
    throw new Error('Invalid key format for delete');
  }

  /** Remove every entry whose value === face */
  deleteByValue(face: T): void {
    for (const [k, v] of this.entries()) {
      if (v === face) super.delete(k);
    }
  }
}
